"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadgerSDK = void 0;
const api_1 = require("./api");
const constants_1 = require("./config/constants");
const network_config_1 = require("./config/network/network.config");
const digg_service_1 = require("./digg/digg.service");
const ibbtc_service_1 = require("./ibbtc/ibbtc.service");
const registry_service_1 = require("./registry/registry.service");
const rewards_service_1 = require("./rewards/rewards.service");
const setts_service_1 = require("./setts/setts.service");
const tokens_service_1 = require("./tokens/tokens.service");
class BadgerSDK {
    constructor(network, provider, baseURL = api_1.DEFAULT_API_URL) {
        this.provider = provider;
        if (!BadgerSDK.initialized) {
            for (const config of constants_1.SUPPORTED_NETWORKS) {
                network_config_1.NetworkConfig.register(config);
            }
            BadgerSDK.initialized = true;
        }
        this.config = network_config_1.NetworkConfig.getConfig(network);
        this.signer = this.provider.getSigner();
        this.loading = this.initialize();
        this.api = new api_1.BadgerAPI(this.config.network, baseURL);
        this.registry = new registry_service_1.RegistryService(this);
        this.tokens = new tokens_service_1.TokensService(this);
        this.setts = new setts_service_1.SettsService(this);
        this.rewards = new rewards_service_1.RewardsService(this);
        this.digg = new digg_service_1.DiggService(this);
        this.ibbtc = new ibbtc_service_1.ibBTCService(this);
    }
    async ready() {
        return Promise.all([this.loading, this.rewards.ready()]);
    }
    async initialize() {
        try {
            if (this.signer) {
                this.address = await this.signer.getAddress();
            }
        }
        catch { } // ignore errors from getting address
    }
}
exports.BadgerSDK = BadgerSDK;
BadgerSDK.initialized = false;
//# sourceMappingURL=sdk.js.map